module.exports = __webpack_public_path__ + "static/media/payment-success.e3054cc6.svg";